module.exports = __webpack_public_path__ + "img/test-image-component-img.05f02938.jpg";